<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getList, add, del, update } from "@/api/system/costSuject";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
export default {
  name: "costSuject",

  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: getList,
        del,
        add,
        update,
        getCountry,
        beforeHandleList({ data }) {
          return data;
        },
        afterHandleList() {
          this.getTable().setAllTreeExpand(true);
        },
      },
      config: {
        height: 630,
        treeConfig: {
          children: "children",
          expandAll: true,
        },
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "city_name cannot be empty",
                  trigger: "blur",
                },
              ],
              en_title: [
                {
                  required: true,
                  message: "city_code cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { title: 24 },
            { en_title: 24 },
            { remarks: 24 },
            { sort: 24 },
          ],
          fields: [
            {
              name: () => this.$t("sujectName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("sujectName");
              },
            },
            {
              name: () => this.$t("sujectName") + this.$t("En"),
              key: "en_title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("sujectName") + this.$t("En");
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
              default: 99,
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [],
        btns: {
          list: [
            // {
            //   name: () => this.$t("add"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     icon: "md-add",
            //     type: "warning",
            //   },
            //   // id: 647,
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      footer: { show: () => false },
      fields: [
        // {
        //   type: "checkbox",
        //   width: 60,
        // },
        {
          name: () => this.$t("sujectName"),
          key: "title",
          minWidth: 100,
          align: "left",
          columnBind: {
            "tree-node": true,
          },
          render(h, { row }) {
            return h("div", {}, [
              h(
                "span",
                row.children && row.children.length
                  ? {
                      style: {
                        // color: "#1890ff",
                        fontWeight: "bold",
                      },
                    }
                  : {},
                row.title
              ),
            ]);
          },
        },
        {
          name: () => this.$t("sujectName") + this.$t("En"),
          key: "en_title",
          minWidth: 100,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 100,
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",

          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("child"),
              type: "add",
              fnName: "update",
              bind: {
                type: "primary",
              },
              show: ({ row }) => !row.pid,
              // id: 646,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              // id: 646,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              // id: 645,
            },
          ],

          methods: {
            update({ row, field }) {
              console.log(arguments);
              this.getModal("add").setTitle(
                field.type == "add"
                  ? this.$t("add") + this.$t("child")
                  : this.$t("update")
              );
              this.getModal("add").type = field.type;
              this.getModal("add").open(
                field.type == "add" ? { id: row.id } : row
              );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  mounted() {},
};
</script>
